import React from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'
import { Navigate, useParams } from 'react-router-dom'

import { getSlugFromPrettyUrl } from '@data/util/urlHelpers'

import { PresentationScreenContentWrapperLegacyUrlQuery } from './__generated__/PresentationScreenContentWrapperLegacyUrlQuery.graphql'
import { PresentationScreenContentWrapperQuery } from './__generated__/PresentationScreenContentWrapperQuery.graphql'

import { PresentationScreenContent } from './PresentationScreenContent'

const PresentationScreenContentWrapperLegacyUrl = () => {
  const params = useParams()
  const data = useLazyLoadQuery<PresentationScreenContentWrapperLegacyUrlQuery>(
    graphql`
      query PresentationScreenContentWrapperLegacyUrlQuery($id: ID!) {
        node(id: $id) {
          __typename

          ... on Presentation {
            prettyUrl
          }
        }
      }
    `,
    { id: params.presentationId! }
  )

  // when we deprecate PresentationScreenContentWrapperLegacyUrl
  // move this '404 not found' logic to PresentationScreenContentWrapper
  if (!data.node || data.node.__typename !== 'Presentation') {
    // TODO: 404 not found page
    return null
  }

  return <Navigate to={`/presentations/${data.node.prettyUrl}`} replace />
}

export const PresentationScreenContentWrapper = () => {
  const params = useParams()
  const data = useLazyLoadQuery<PresentationScreenContentWrapperQuery>(
    graphql`
      query PresentationScreenContentWrapperQuery($slug: String!) {
        presentationBySlug(slug: $slug) {
          ...PresentationScreenContent_presentation
        }
      }
    `,
    { slug: getSlugFromPrettyUrl(params.presentationId) }
  )

  if (!data.presentationBySlug) {
    return <PresentationScreenContentWrapperLegacyUrl />
  }

  return <PresentationScreenContent presentation={data.presentationBySlug} />
}

export default PresentationScreenContentWrapper
